export default __webpack_public_path__ + "static/media/LENS_CULINARIS_OGRE_fragment_7.9629e69e.jpg";